import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import {
  TEXT_GREY_DARK,
  OUTLINE_COLOR_LIGHT,
} from '@CSSVars/colors'


export const _VerticalTimeLineElement = styled.div`
  position: relative;
  margin-bottom: 16px;
  > div {
    min-height: 1px;
  }
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  &:first-child {
    margin-top: 24px;
  }
  @media only screen and (min-width: 1170px) {
    &:first-child {
      margin-top: ${({ isAddressPage }) => (isAddressPage ? '18px' : '0')};
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  @media only screen and (max-width: ${BREAK_POINT_MD}) {
    &:first-child {
      margin-top: ${({ isAddressPage }) => (isAddressPage ? '0' : '24px')};
    }
  }
  ${({ growMargin }) => (growMargin && `
    margin-bottom: 13px !important;
  `)}
`

export const _VerticalTimeLineHeader = styled.div`
  margin-bottom: 14px;
  line-height: 22px;
  ${({ visible }) => (!visible && `
    margin-bottom: 0px;
  `)}

`

export const _Date = styled.span`
  font-weight: 600
`

export const _ListedAndSold = styled.span`
  color: ${TEXT_GREY_DARK};

`

export const _DisplayChildrenLarge = styled.div`
  @media only screen and (max-width: 767px) {
    display: none
  }

`
export const _DisplayChildrenSmall = styled.div`
  display: none;
  @media only screen and (max-width: 767px) {
     display: block;
  }

`

export const _VerticalTimelineElementContent = styled.div`
  position: relative;
  background: white;
  ${({ noChildren }) => (noChildren && `
    background: transparent;
    box-shadow: none;
  `)}
  &:after {
    content: "";
    display: table;
    clear: both;
  }
`
export const _DisplayBorder = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid ${OUTLINE_COLOR_LIGHT};

`
